<template>
    <modal width="300" :show-modal="showModal" @close-modal="$emit('close-modal')" :styleContent="{ minWidth: '80%' }">
        <div class="w-full">
            <ViewShipments :selecetedActionShipment="selecetedActionShipment"/>
        </div>
    </modal>
</template>

<script>
import ViewShipments from "../../Consolidation/view-shipment.vue"
export default {
    components: {
        ViewShipments
    },
    props: {
        selecetedActionShipment: {},
        showModal: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
        }
    },

    methods: {
        closeModal() {
            this.$emit("close-modal");
        },
    }
};
</script>

<style scoped>
.delete-modal {
    text-align: center;
}
</style>